/**
 * Session store — tracks who's signed in client-side.
 *
 * Single source of truth for `isAdmin` (so the nav can conditionally
 * render the admin link) plus the cached display name (for the topbar).
 * Wired in main.ts: every successful whoami() flush calls
 * `setCurrentUser`, every logout calls `setCurrentUser(null)`.
 *
 * Svelte 5 runes module — must be .svelte.ts so consumers can $derive
 * from `session.user`.
 */

export interface CurrentUser {
  membershipId: string;
  displayName: string;
  isAdmin: boolean;
}

let _user: CurrentUser | null = $state(null);

export const session = {
  get user(): CurrentUser | null {
    return _user;
  },
  get isAdmin(): boolean {
    return _user?.isAdmin === true;
  },
};

export function setCurrentUser(u: CurrentUser | null): void {
  _user = u;
}
